const MOBILE_QUERY_VALUES = new Set(["1", "true", "yes"]);

export const isMobileQueryParamEnabled = (value) =>
  MOBILE_QUERY_VALUES.has(String(value || "").trim().toLowerCase());
